import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Documents from './pages/Documents';
import DocumentView from './pages/DocumentView';
import Upload from './pages/Upload';
import Receipts from './pages/Receipts';
import Reconciliation from './pages/Reconciliation';
import EnhancedReconciliation from './pages/EnhancedReconciliation';
import Duplicates from './pages/Duplicates';
import Categories from './pages/Categories';
import Search from './pages/Search';
import SmartSearch from './pages/SmartSearch';
import QuickReports from './pages/QuickReports';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/documents/:id" element={<DocumentView />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/receipts" element={<Receipts />} />
        <Route path="/reconciliation" element={<Reconciliation />} />
        <Route path="/reconciliation/enhanced" element={<EnhancedReconciliation />} />
        <Route path="/duplicates" element={<Duplicates />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/search" element={<Search />} />
        <Route path="/smart-search" element={<SmartSearch />} />
        <Route path="/quick-reports" element={<QuickReports />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </Layout>
  );
}

export default App;

